const labels = <NodeListOf<HTMLParagraphElement>>document.querySelectorAll('.partnerDisplay__labels p');
const lists = <NodeListOf<HTMLUListElement>>document.querySelectorAll('.partnerDisplay__cols ul');
const indicator = <HTMLSpanElement>document.querySelector('.partnerDisplay__indicator--active');

labels.forEach((label, index) => {
  // Store label ammount
  const max = labels.length - 1;
  if (index === max) {
    // Set indicator transform to last item
    indicator.style.width = `${labels[max].offsetWidth}px`;
    indicator.style.transform = `translateX(${labels[max].offsetLeft}px)`;
  }

  label.addEventListener('click', () => {
    // Remove active from all labels
    labels.forEach((labelInner) => {
      labelInner.classList.remove('active');
    });

    // Add active to target label
    label.classList.add('active');

    // Set indicator transform
    indicator.style.width = `${label.offsetWidth}px`;
    indicator.style.transform = `translateX(${label.offsetLeft}px)`;

    // Get target
    const target = label.dataset.for;

    // Loop over all list items
    // Set active to target, remove from others
    lists.forEach((list) => {
      if (list.dataset.for === target) {
        list.dataset.active = 'true';
      } else {
        list.dataset.active = 'false';
      }
    });
  });
});
